import { useState } from 'react'
import { GridDiv } from 'entities/GridDiv'
import { FileInput } from 'entities/FileInput'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { HelpEnum, HelpModal } from './HelpModal'
import { ImagesContainer } from './styled'

export const ImagesPicker = () => {
  const updateInterface = useConfigStore().updateInterface
  const config = useConfigStore().config
  const isCC = useGlobalStore().isCCSelected
  const images = config?.interfaceConfig?.[getAppName(isCC)]

  const [currentOpenHelp, setCurrentOpenHelp] = useState<HelpEnum>()

  const updateImage = (param: 'appIcon' | 'logoImage' | 'backgroundImage') => (value: string) => {
    updateInterface({ [param]: value })
  }

  const deleteImage = (param: 'appIcon' | 'logoImage' | 'backgroundImage') => () => {
    updateInterface({ [param]: null })
  }

  return (
    <ImagesContainer>
      <GridDiv $gc='1/2' $gr='1/-1'>
        <FileInput
          id='BackgroundImage'
          height={610}
          width={300}
          background={images?.backgroundImage}
          title='Background Image'
          onChange={updateImage('backgroundImage')}
          onDelete={deleteImage('backgroundImage')}
          onHelpClick={() => {
            setCurrentOpenHelp(HelpEnum.BACKGROUND_IMAGE)
          }}
        />
      </GridDiv>
      <GridDiv $gc='2/-1' $gr='1/2' $jc='space-between'>
        <FileInput
          id='LogoImage'
          height={300}
          width={300}
          background={images?.logoImage}
          title='Logo Image'
          onChange={updateImage('logoImage')}
          onDelete={deleteImage('logoImage')}
          onHelpClick={() => {
            setCurrentOpenHelp(HelpEnum.LOGO_IMAGE)
          }}
        />
      </GridDiv>
      <GridDiv $gc='2/-1' $gr='2/-1' $jc='space-between'>
        <FileInput
          id='AppIcon'
          height={300}
          width={300}
          background={images?.appIcon}
          title='App Icon'
          onChange={updateImage('appIcon')}
          onDelete={deleteImage('appIcon')}
          onHelpClick={() => {
            setCurrentOpenHelp(HelpEnum.APP_IMAGE)
          }}
        />
      </GridDiv>
      <HelpModal
        isOpen={!!currentOpenHelp}
        headerTitle={currentOpenHelp}
        helpType={currentOpenHelp}
        onClose={() => setCurrentOpenHelp(undefined)}
      />
    </ImagesContainer>
  )
}
